import "./TermsAndCondition.scss";
import { useSelector, useDispatch } from "react-redux";
import Layout from "../../components/layout/Layout";
import { useQuery } from "react-query";
import { setLanguageIntial } from "../../store/language.slice";
import { languageGetApi } from "../../services/affiliateApi";

function TermsAndCondition() {
  const dispatch = useDispatch();
  const { affiliate } = useSelector((state) => state.language?.activelang);
  const lnFromStore = useSelector((state) => state.language);
  const language = "en";

  let { isLoading } = useQuery(
    ["policyTerms", language],
    languageGetApi.bind(null, language, "policyTerms"),
    {
      enabled: !lnFromStore[language],
      onSuccess: (o) => dispatch(setLanguageIntial({ k: language, v: o })),
    }
  );

  const policyTerms = useSelector(
    (state) => state.language?.activelang?.policyTerms
  );
  const displayTerms = process.env.REACT_APP_NAME === "data2go" ? policyTerms?.affiliateTerms : policyTerms?.corporateTerms
  const termsAndConditions = !!displayTerms ?  JSON.parse(displayTerms) : {};

  return (
    <Layout>
      {isLoading ? (
        <div className="loading_content">
          <div>
          <i className="pi pi-spin pi-spinner"></i>
          <h2>{affiliate.AFFNL0149 || "Loading..."}</h2>
          </div>
        </div>
      ) : (
        <section className="about-blocks-section tc-block">
          <div className="terms-and-conditions-section">
            <h1>{termsAndConditions.title}</h1>
            <div
              dangerouslySetInnerHTML={{
                __html: termsAndConditions.description,
              }}
            ></div>
          </div>
        </section>
      )}
    </Layout>
  );
}

export default TermsAndCondition;
